// extracted by mini-css-extract-plugin
export default {"wrapper":"sp0Bts","label":"lVsaxH","line":"H2Mqot","inner-wrapper":"YQa65v","innerWrapper":"YQa65v","address":"vaMyp6","error":"lYZKJd"};